import React, { useState, useEffect } from "react";
import axios from "axios";
import { Slidar } from "../AdminDashbord/Slidar";
import "./GalleryEdit.css";

const GalleryEdit = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [images, setImages] = useState({ folders: [], ungroupedImages: [] });
  const [folderName, setFolderName] = useState("");
  const [expandedFolders, setExpandedFolders] = useState({});

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = () => {
    axios
      .get("/api/gallery")
      .then((res) => setImages(res.data))
      .catch((err) => console.error("Fetch error:", err));
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter((file) => file.size <= 512 * 1024);

    if (validFiles.length !== files.length) {
      alert("Some files were larger than 512KB and were skipped.");
    }

    const fileObjects = validFiles.map((file) => ({
      file,
      text: "",
      preview: URL.createObjectURL(file),
    }));

    setSelectedFiles(fileObjects);
  };

  const handleCaptionChange = (index, value) => {
    const updated = [...selectedFiles];
    updated[index].text = value;
    setSelectedFiles(updated);
  };

  const handleUpload = async () => {
    if (selectedFiles.length === 0) {
      return alert("Please select image(s) under 512KB.");
    }

    try {
      const formData = new FormData();
      selectedFiles.forEach(({ file }) => formData.append("images", file));
      formData.append("texts", JSON.stringify(selectedFiles.map((item) => item.text)));

      // Only append folder if a valid name is provided
      const trimmedFolder = folderName.trim();
      if (trimmedFolder) {
        formData.append("folder", trimmedFolder);
      }

      await axios.post("/api/gallery/bulk", formData);
      setSelectedFiles([]);
      setFolderName("");
      fetchImages();
    } catch (err) {
      console.error("Upload error:", err);
      alert("Upload failed. Check console for details.");
    }
  };

  const handleDelete = async (imageId, folderId = null) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this image?");
    if (!confirmDelete) return;

    const url = folderId
      ? `/api/folders/${folderId}/images/${imageId}`
      : `/api/gallery/${imageId}`;

    try {
      await axios.delete(url);
      fetchImages();
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete image.");
    }
  };

  const handleDeleteFolder = async (folderId) => {
    const confirmDelete = window.confirm("Delete this folder and all its images?");
    if (!confirmDelete) return;

    try {
      await axios.delete(`/api/gallery/folder/${folderId}`);
      fetchImages();
    } catch (err) {
      console.error("Folder delete error:", err);
      alert("Failed to delete folder.");
    }
  };

  const toggleFolder = (folderId) => {
    setExpandedFolders((prev) => ({
      ...prev,
      [folderId]: !prev[folderId],
    }));
  };

const handleUpdateCaptionAndImage = async (imageId, folderId, text, newFile) => {
  try {
    const formData = new FormData();
    formData.append("text", text);
    if (newFile) formData.append("image", newFile); // new image file

    const res = await axios.put(
      `/api/folders/${folderId}/images/${imageId}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    alert("Updated successfully!");
  } catch (err) {
    console.error(err);
    alert("Update failed.");
  }
};



  return (
    <div className="d-flex">
      <Slidar />
      <div className="gallery-admin-container">
        <h2 className="gallery-title">Gallery Admin Panel</h2>

        {/* Upload Section */}
        <div className="upload-section mb-4">
          <label style={{ marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>
    Folder Name (if dont want to add in ungrouped images leave it blank)
  </label>
          <input
            type="text"
            placeholder="Enter folder name (optional)"
            value={folderName}
            onChange={(e) => setFolderName(e.target.value)}
            className="form-control mb-2"
             style={{ width: '200px', padding: '8px', fontSize: '14px', borderRadius: '6px'}}
          />
          <div className="mobile">
            <label style={{ marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>
    Add Images (you can add multiple images, max 512KB each)
  </label>
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={handleFileChange}
            className="form-control"
             style={{ width: '300px', padding: '8px', fontSize: '14px', borderRadius: '6px' }}
          />
          </div>

          {/* Selected Files Preview */}
          {selectedFiles.length > 0 && (
            <div className="preview-grid mt-3">
              {selectedFiles.map((item, index) => (
                <div className="preview-card" key={index}>
                  <img src={item.preview} alt="Preview" />
                  <input
                    type="text"
                    placeholder="Enter caption"
                    value={item.text}
                    onChange={(e) => handleCaptionChange(index, e.target.value)}
                  />
                </div>
              ))}
              <button className="upload-btn btn btn-primary mt-3" onClick={handleUpload}>
                Upload All
              </button>
            </div>
          )}
        </div>

        <hr />

        {/* Folder Section */}
        {images.folders.map((folder) => (
         <div key={folder._id} className="mt-4 folder-section">
  <div className="d-flex justify-content-between align-items-center">
    
    <h5 style={{ cursor: "pointer" }} onClick={() => toggleFolder(folder._id)}>
      📁 {folder.name || "All"}
    </h5>
    <button
      className="btn btn-outline-danger btn-sm"
      onClick={() => handleDeleteFolder(folder._id)}
    >
      Delete Folder
    </button>
  </div>

 {expandedFolders[folder._id] && (
  <div className="uploaded-grid mt-2">
    {folder.images?.map((img) => (
      <div key={img._id} className="uploaded-card">
        <img
          src={img.previewUrl || `${img.url}`}
          alt="Uploaded"
          style={{ width: "100%", height: "auto" }}
        />

        {/* Text input */}
        <input
          type="text"
          value={img.text}
          onChange={(e) => {
            const updatedText = e.target.value;
            setImages((prev) => {
              const updatedFolders = prev.folders.map((f) => {
                if (f._id === folder._id) {
                  const updatedImages = f.images.map((i) =>
                    i._id === img._id ? { ...i, text: updatedText } : i
                  );
                  return { ...f, images: updatedImages };
                }
                return f;
              });
              return { ...prev, folders: updatedFolders };
            });
          }}
          placeholder="Enter caption"
          className="mt-1"
        />

        {/* File input to select new image */}
        <input
          type="file"
          onChange={(e) => {
            const file = e.target.files[0];
            if (!file) return;

            // Update preview
            const previewUrl = URL.createObjectURL(file);

            setImages((prev) => {
              const updatedFolders = prev.folders.map((f) => {
                if (f._id === folder._id) {
                  const updatedImages = f.images.map((i) =>
                    i._id === img._id ? { ...i, newFile: file, previewUrl } : i
                  );
                  return { ...f, images: updatedImages };
                }
                return f;
              });
              return { ...prev, folders: updatedFolders };
            });
          }}
          className="mt-1"
        />

        {/* Buttons */}
        <div className="button-group mt-1">
          <button
            className="btn btn-success btn-sm"
            onClick={() =>
              handleUpdateCaptionAndImage(img._id, folder._id, img.text, img.newFile)
            }
          >
            Update
          </button>
          <button
            className="btn btn-danger btn-sm ms-1"
            onClick={() => handleDelete(img._id, folder._id)}
          >
            Delete
          </button>
        </div>
      </div>
    ))}
  </div>
)}

  
</div>

        ))}

        {/* Ungrouped Images */}
        <div className="mt-5">
          {/* <h5>🖼️ Ungrouped Images</h5> */}
          <div className="uploaded-grid">
            {images.ungroupedImages.map((img) => (
              <div key={img._id} className="uploaded-card">
                <img src={`${img.url}`} alt="Uploaded" />
                <p>{img.text}</p>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(img._id)}
                >
                  Delete
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryEdit;
